export default {
  aside: {
    menu: {
      home: '首页',
      creative: {
        name: '模板库',
        playable: '可玩模板',
        video: '视频模板',
      },
      myproject: {
        name: '我的项目',
        record: '录屏项目',
        playable: '可玩项目',
        videoAndImage: '图片项目',
        export: '导出&下载历史',
      },
      service: {
        name: '创意服务',
        playable: '定制可玩广告',
        image: '定制图片&视频',
      },
      myassets: {
        name: '我的资产',
        asset: '创意资产',
        template: '模板资产',
      },
      accountManagement: {
        name: '费用中心',
        billing: {
          usage: '套餐使用',
          materials: '素材费用',
        },
        profile: '基本信息',
        reset: '修改密码',
      },
      settings: {
        name: '账户设置',
        promote: '推广产品',
        record: '参数字典',
      },
      poinitManagement: {
        title: '可玩素材埋点管理',
      },
    },
  },
}
